import { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function NavigationMenu() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const isCrowdfundingActive = () => {
    return location.pathname.startsWith('/crowdfunding');
  };

  return (
    <nav className="hidden md:flex items-center space-x-8">
      <Link 
        to="/" 
        className={`transition-colors whitespace-nowrap ${
          isActive('/') 
            ? 'text-yellow-300 font-semibold' 
            : 'text-white hover:text-teal-200'
        }`}
      >
        Home
      </Link>
      <Link 
        to="/sap-dangers" 
        className={`transition-colors whitespace-nowrap ${
          isActive('/sap-dangers') 
            ? 'text-yellow-300 font-semibold' 
            : 'text-white hover:text-teal-200'
        }`}
      >
        SAP Dangers
      </Link>
      <Link 
        to="/crowdfunding" 
        className={`transition-colors whitespace-nowrap ${
          isCrowdfundingActive() 
            ? 'text-yellow-300 font-semibold' 
            : 'text-white hover:text-teal-200'
        }`}
      >
        Crowd Funding
      </Link>
      <Link 
        to="/technology" 
        className={`transition-colors whitespace-nowrap ${
          isActive('/technology') 
            ? 'text-yellow-300 font-semibold' 
            : 'text-white hover:text-teal-200'
        }`}
      >
        Technology
      </Link>
      <Link 
        to="/admin" 
        className={`transition-colors whitespace-nowrap ${
          isActive('/admin') 
            ? 'text-yellow-300 font-semibold' 
            : 'text-white hover:text-teal-200'
        }`}
      >
        Admin
      </Link>
    </nav>
  );
}
